import React from "react"
import SeoLandingPage from "./SeoLandingPage"
import { SEO_KEYWORDS_EXTRA } from "../../seo/extraKeywords"

export default function BpedAdmissionOdisha() {
  return (
    <SeoLandingPage
      path="/b-p-ed-admission-odisha"
      title="Best BP.Ed Institute Odisha | Top B.P.Ed Admission Coaching 2026"
      description="Top BP.Ed (B.P.Ed) admission support in Odisha: counselling, coaching, admission processing, books and online classes—Bhadrak office for Bhadrak, Balasore, Karanjia & statewide students."
      keywords={`best BP.Ed institute Odisha, BP.Ed Bonth Bhadrak, BP.Ed Andapur, BP.Ed Chhenapadi, BP.Ed Thakurmunda Mayurbhanj, top B.P.Ed institute Odisha, BP.Ed admission Odisha, B.P.Ed coaching Odisha, BP.Ed college Odisha, physical education admission Odisha, BP.Ed Bhadrak, BP.Ed Balasore, BP.Ed Karanjia Mayurbhanj, sports teacher training Odisha, ${SEO_KEYWORDS_EXTRA}`}
      h1="Best BP.Ed Admission Support in Odisha — Counselling + Coaching"
      intro="For students searching the best BP.Ed institute in Odisha or top B.P.Ed admission coaching, we provide end-to-end guidance: counselling, eligibility support, admission processing, books and online coaching—with Bhadrak office visits when you need offline help."
      bullets={[
        "BP.Ed admission counselling for Odisha students",
        "Eligibility guidance and admission steps",
        "Form fill-up and document support",
        "Offline book distribution from Bhadrak office",
        "Online coaching/classes for BP.Ed students",
        "Support for students from Bhadrak, Balasore and nearby areas",
      ]}
      areaServed={[
        { "@type": "State", name: "Odisha" },
        { "@type": "City", name: "Bhadrak" },
        { "@type": "Place", name: "Bonth" },
        { "@type": "Place", name: "Andapur" },
        { "@type": "Place", name: "Chhenapadi" },
        { "@type": "Place", name: "Thakurmunda" },
        { "@type": "City", name: "Balasore" },
        { "@type": "City", name: "Baripada" },
        { "@type": "City", name: "Mayurbhanj" },
        { "@type": "City", name: "Karanjia" },
      ]}
      faqs={[
        {
          q: "Do you provide online coaching for BP.Ed?",
          a: "Yes. We provide online classes and coaching support along with admission guidance.",
        },
        {
          q: "I searched “BP.Ed institute near me” — do you provide counselling in Odisha?",
          a: "Yes. We provide BP.Ed admission counselling and coaching support across Odisha, with offline office support available in Bhadrak.",
        },
        {
          q: "Can I visit the office for counselling?",
          a: "Yes. Students can visit our Bhadrak office for counselling, document verification support and study material/book distribution.",
        },
        {
          q: "Is BP.Ed admission support available for Balasore/Bhadrak students?",
          a: "Yes. We regularly support students from Bhadrak, Balasore and nearby districts across Odisha.",
        },
      ]}
    />
  )
}

